<template>
  <div class="profile">
    <BioComponent :extra-bio="extraBio" />
    <LanguagesComponent :languages="extraLanguages" />
    <ExperiencesComponent :experiences="extraExperiences" />
    <SkillComponent :skills="extraSkills" :is-haccp-certified="extraHaccpCertif" />
    <CoursesComponent :courses="extraCourses" />
  </div>
</template>

<script setup>
  import {
    GETTER_EXTRA_GET_BIO,
    GETTER_EXTRA_GET_LANGUAGE,
    GETTER_EXTRA_GET_EXTRA_SKILLS,
    GETTER_EXTRA_GET_HACCP_CERTIF,
    GETTER_EXTRA_GET_COURSES,
    GETTER_EXTRA_GET_EXPERIENCES,
  } from "@etab/stores/types";
  import { useExtraStore } from "@etab/stores/extra";
  import { computed } from "vue";

  import BioComponent from "@etab/components/extra/profile/Bio.component.vue";
  import LanguagesComponent from "@etab/components/extra/profile/Languages.component.vue";
  import SkillComponent from "@etab/components/extra/profile/Skills.component.vue";
  import CoursesComponent from "@etab/components/extra/profile/Courses.component.vue";
  import ExperiencesComponent from "@etab/components/extra/profile/Experiences.component.vue";

  const extraStore = useExtraStore();

  const extraBio = computed(() => extraStore[GETTER_EXTRA_GET_BIO]);
  const extraLanguages = computed(() => extraStore[GETTER_EXTRA_GET_LANGUAGE]);
  const extraSkills = computed(() => extraStore[GETTER_EXTRA_GET_EXTRA_SKILLS]);
  const extraHaccpCertif = computed(() => extraStore[GETTER_EXTRA_GET_HACCP_CERTIF]);
  const extraCourses = computed(() => extraStore[GETTER_EXTRA_GET_COURSES]);
  const extraExperiences = computed(() => extraStore[GETTER_EXTRA_GET_EXPERIENCES]);
</script>
